import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Extend dayjs with UTC and timezone plugins
dayjs.extend(utc);
dayjs.extend(timezone);

// Get user's timezone
const getUserTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// Create a custom dayjs instance that automatically converts UTC to local timezone
const customDayjs = (date) => {
  const userTimezone = getUserTimezone();
  
  if (date) {
    // If date is provided, parse it as UTC and convert to user's timezone
    return dayjs.utc(date).tz(userTimezone);
  } else {
    // If no date provided, return current time in user's timezone
    return dayjs().tz(userTimezone);
  }
};

// Copy all dayjs methods to our custom instance
Object.setPrototypeOf(customDayjs, dayjs);
Object.assign(customDayjs, dayjs);

// Utility function to format dates consistently
export const formatDate = (date, format = 'MMM DD, YYYY') => {
  if (!date) return '';
  return customDayjs(date).format(format);
};

// Utility function to format date and time
export const formatDateTime = (date, format = 'MMM DD, YYYY h:mm A') => {
  if (!date) return '';
  return customDayjs(date).format(format);
};

// Utility function to format time only
export const formatTime = (date, format = 'h:mm A') => {
  if (!date) return '';
  return customDayjs(date).format(format);
};

export default customDayjs;
